import React from 'react';

import useResponsive from '../../../../../hooks/useResponsive';

import SenderInfoDesktop, { ISenderInfoDesktopProps } from './SenderInfoDesktop';
import SenderInfoMobile, { ISenderInfoMobileProps } from './SenderInfoMobile';

const SenderInfo = ({ ...props }: ISenderInfoMobileProps & ISenderInfoDesktopProps): JSX.Element => {
  const { isMobile } = useResponsive();
  return isMobile ? <SenderInfoMobile {...props} /> : <SenderInfoDesktop {...props} />;
};

export default SenderInfo;
